import React from 'react';
import AdminResourceManagerPage from '../../components/admin/AdminResourceManagerPage';

export default function AdminSecadDocumentsPage() {
  return (
    <AdminResourceManagerPage
      moduleKey="secretariaSecadDocuments"
      title="Documentos da Secretaria Acadêmica"
      description="Atualize os documentos da Secretaria Acadêmica exibidos no site, com arquivo em PDF ou link de referência."
      createLabel="Novo documento"
      emptyMessage="Nenhum documento cadastrado para a Secad."
    />
  );
}
